import { ref } from "vue";
import { defineStore } from "pinia";
import { Policy } from "@/modules/groups/interfaces/policy";

export const useCompanyGroupPoliciesStore = defineStore(
  "companyGroupPolicies",
  () => {
    const groupPolicies = ref<Policy[]>([]);
    const service = ref<number>(0);

    const setCompanyGroupPolicies = (value: Policy[]) => {
      groupPolicies.value = value;
    };

    return {
      groupPolicies,
      service,

      setService(value: string | number) {
        if (typeof value == "string") {
          service.value = Number(value);
        }
        if (typeof value == "number") {
          service.value = value;
        }
      },
      getCompanyGroupPolicy(name: string) {
        return groupPolicies.value.find((service) => service.name === name);
      },
      setCompanyGroupPolicies,
      resetState() {
        service.value = 0;
        groupPolicies.value = [];
      },
    };
  }
);
